import React, { Component } from 'react';
import { Route } from 'react-router';
import { Layout } from './components/Layout';
import { Home } from './components/Home';
import { FetchData } from './components/FetchData';
import { Counter } from './components/Counter';
import { LicensePlateSearch } from './components/LicensePlateSearch';
import { CompanyList } from './components/CompanyList';

import './custom.css'

export default class App extends Component {
  //static displayName = App.name;
    static displayName = 'Ranger';

  render () {
    return (
      <Layout>
        <Route exact path='/' component={Home} />
        <Route path='/counter' component={Counter} />
        <Route path='/fetch-data' component={FetchData} />
        <Route path='/lpsearch' component={LicensePlateSearch} />
        <Route path='/colist' component={CompanyList} />
      </Layout>
    );
  }
}
